export enum StandardMaterialDebugMode {
  alpha = "alpha",
  emissive = "emissive",
  f0 = "f0",
  metallic = "metallic",
  normal = "normal",
  occlusion = "occlusion",
  roughness = "roughness"
}